import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MyBox from './MyBox';
import Home from './Home';

function App() {
  return (
    <Router>
     <div className="container">
     <Routes>
        <Route exact path="/publications" element={<MyBox/>}/>
        <Route exact path="/publication" element={<MyBox/>}/>
        <Route exact path="/" element={<Home/>}/>
        <Route path="*" element={<Home/>}/>
      </Routes>
      <footer className="footer">
        <p>Contact: <a href='mailto:88.prithaghosh@gmail.com'>88.prithaghosh@gmail.com</a></p>
      </footer>
    </div>  
  </Router>  
  );
}

export default App;
